import { render, staticRenderFns } from "./created-successfully-modal.vue?vue&type=template&id=7ed78aae&scoped=true&"
import script from "./created-successfully-modal.vue?vue&type=script&lang=js&"
export * from "./created-successfully-modal.vue?vue&type=script&lang=js&"
import style0 from "./created-successfully-modal.vue?vue&type=style&index=0&id=7ed78aae&lang=scss&scoped=true&"
import style1 from "./created-successfully-modal.vue?vue&type=style&index=1&id=7ed78aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed78aae",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QAvatar} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QAvatar})
